export const socket = new WebSocket('wss://group-chat-server.onrender.com');
